import React from 'react';
import ReactStars from 'react-rating-stars-component';

/**
 * @deprecated Legacy entry point for react-rating-stars-component, kept so the testimonial rating looks and behaves
 * as before. React 19's jsx() runtime ignores a function component's defaultProps, which would render no stars, so
 * the package defaults the app relies on are passed explicitly; caller props still win. Never import
 * react-rating-stars-component directly; new ratings use a maintained component.
 * @param {Object} props react-rating-stars-component props (value, onChange, size, activeColor ...).
 */
function RatingStars(props) {
    return (
        <ReactStars count={5} edit={true} char="★" color="gray" a11y={true} {...props} />
    );
}

export default RatingStars;
